import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface CampWorkflowJobDoneNotifyFollowerProps extends BaseTemplateProps {
  stepName: string
  successfulCount: number
  failedCount: number
  unknownCount: number
  stepLink: string
  resultId?: string
}

export const CampWorkflowJobDoneNotifyFollower: TemplateDefinition<CampWorkflowJobDoneNotifyFollowerProps> =
  {
    renderParams: (props: CampWorkflowJobDoneNotifyFollowerProps) => {
      const baseValues = {
        stepName: props.stepName,
        successfulCount: props.successfulCount,
        failedCount: props.failedCount,
        unknownCount: props.unknownCount,
      }
      // Legacy notifications (persisted before Waves started sending result_id)
      // omit resultId. Fall back to the original key so React Intl doesn't blow
      // up on an unresolved {resultId} placeholder.
      return props.resultId
        ? {
            messageKey:
              'notificationsDomain.templates.campWorkflowJobDoneNotifyFollowerWithResultId',
            values: { ...baseValues, resultId: props.resultId },
          }
        : {
            messageKey: 'notificationsDomain.templates.campWorkflowJobDoneNotifyFollower',
            values: baseValues,
          }
    },
    getLink: (props: CampWorkflowJobDoneNotifyFollowerProps): string => props?.stepLink || '',
  }
